import {
  CLEAN_ORDER_VINCULATION_LIST,
  CLEAN_ORDER_VINCULATION_LIST_ERROR,
  ORDER_VINCULATION_LIST,
  ORDER_VINCULATION_LIST_ERROR,
} from '_models/redux/types';

const initialState = {
  loaded: undefined,
  method: undefined,
  payload: undefined,
  status: undefined,
  state: undefined,
};

export default function orderVinculationListReducer(state = initialState, action) {
  switch (action.type) {
    case ORDER_VINCULATION_LIST:
      return {
        ...state,
        loaded: true,
        method: action?.method || null,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'success',
      };

    case ORDER_VINCULATION_LIST_ERROR:
      return {
        ...state,
        loaded: true,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'error',
      };

    case CLEAN_ORDER_VINCULATION_LIST:
      return {
        ...state,
        loaded: false,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'success',
      };

    case CLEAN_ORDER_VINCULATION_LIST_ERROR:
      return {
        ...state,
        loaded: false,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'error',
      };
    default:
      return state;
  }
}
